import React from 'react';
import { createContext } from 'react';

export interface ILayoutFooterProviderProps {
  children: React.ReactNode;
}

const LayoutFooterContext = createContext<{
  height: number;
  useResizeEffect: (headerRef: React.RefObject<HTMLElement | null>) => void;
}>({
  height: 0,
  useResizeEffect: () => {},
});

function LayoutFooterProvider({ children }: ILayoutFooterProviderProps) {
  const [height, setHeight] = React.useState<number>(0);

  const useResizeEffect = (footerRef: React.RefObject<HTMLElement | null>) =>
    React.useEffect(() => {
      footerRef.current?.clientHeight &&
        setHeight(footerRef.current.clientHeight);

      window.addEventListener('resize', () => {
        footerRef.current?.clientHeight &&
          setHeight(footerRef.current.clientHeight);
      });

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <LayoutFooterContext.Provider
      value={{
        height,
        useResizeEffect,
      }}
    >
      {children}
    </LayoutFooterContext.Provider>
  );
}

export { LayoutFooterContext, LayoutFooterProvider };
